export default function userSessionreducer(state = {
    logged_in: false,
    user: {},
    oem_loaded: false
}, action) {
    switch(action.type) {
        case "SET_SESSION" :{
            return state = {
                ...state,
                user: action.payload,
                logged_in: true,
                oem_loaded: false
            }
        }

        case "SET_SESSION_OEM" :{
            return state = {
                ...state,
                user: action.payload,
                logged_in: true,
                oem_loaded: true
            }
        }

        case "DESTROY_SESSION" :{
            return state = {
                ...state,
                user: {},
                logged_in: false
            }
        }

        default: {

        }
    }

    return state;
}